import zhCN from './locales/zh-cn'
import enUS from './locales/en-us'
import { createI18n } from 'vue-i18n'
import type { App } from 'vue'

export const defaultLocale = 'zh-CN'

const i18n = createI18n({
  locale: defaultLocale,
  fallbackLocale: 'en-US',
  allowComposition: true,
  messages: {
    'en-US': enUS,
    'zh-CN': zhCN,
  },
})

export const t = i18n.global.t

export function setupI18n(app: App) {
  app.use(i18n)
}

export default i18n
